export enum ValidationPatterns {
    PhoneNumber = '^[0-9]{1,12}$',
  }